import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Overview = () => {
  return (
    <EmptyPage
      title="Analytics Overview"
      description="Get a comprehensive view of your real estate portfolio performance, deal metrics, and key insights across all your projects and valuations."
      icon="📊"
    />
  );
};

export default Overview;
